// Vzhled (motiv, barvy, písmo) a režim levého menu — nastaví se hned při načtení.
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)

var APPEARANCE_KEY = 'audit_app_appearance_v1';
function loadAppearance(){
  try{
    var raw = localStorage.getItem(APPEARANCE_KEY);
    if(!raw) return {theme:'auto', accent:'blue', fontSize:'m', colorblindMode:false, navBadges:true, myTasks:true};
    var p = JSON.parse(raw);
    return {
      theme: (p && ['light','dark','auto'].indexOf(p.theme)>=0) ? p.theme : 'auto',
      accent: (p && ['blue','teal','violet','terracotta'].indexOf(p.accent)>=0) ? p.accent : 'blue',
      fontSize: (p && ['s','m','l'].indexOf(p.fontSize)>=0) ? p.fontSize : 'm',
      colorblindMode: !!(p && p.colorblindMode),
      navBadges: !(p && p.navBadges===false),
      myTasks: !(p && p.myTasks===false)
    };
  }catch(e){ return {theme:'auto', accent:'blue', fontSize:'m', colorblindMode:false, navBadges:true, myTasks:true}; }
}
function saveAppearance(a){
  try{ localStorage.setItem(APPEARANCE_KEY, JSON.stringify(a)); }catch(e){}
}
var appearance = loadAppearance();
// Levý sloupec na desktopu — režim v tomto prohlížeči: 'wide' (trvale
// široký), 'narrow' (trvale úzký, jen ikony), 'hover' (úzký, po najetí
// myší se rozšíří přes obsah). Volí se ikonou vlevo dole (#navMode).
var NAV_MODE_KEY = 'bozp-nav-mode';
var NAV_MODES = ['wide','narrow','hover'];
var navMode = 'wide';
try{
  navMode = localStorage.getItem(NAV_MODE_KEY) || (localStorage.getItem('bozp-nav-collapsed')==='1' ? 'narrow' : 'wide');
}catch(e){}
if(NAV_MODES.indexOf(navMode)<0) navMode = 'wide';
var navCollapsed = navMode!=='wide';
function setNavModeValue(mode){ navMode = mode; navCollapsed = mode!=='wide'; }
function applyNavModeClasses(){
  var r = document.documentElement;
  r.classList.toggle('nav-collapsed', navCollapsed);
  r.classList.toggle('nav-hover-mode', navMode==='hover');
  if(navMode!=='hover') r.classList.remove('nav-peek');
}
applyNavModeClasses();

export {
  NAV_MODES,
  NAV_MODE_KEY,
  appearance,
  applyNavModeClasses,
  navMode,
  saveAppearance,
  setNavModeValue
};
